import { AppState } from '../reducers';

export const selectStoredTemplate = (state: AppState) => state.smsSequence.template;
export const getSelectedContactId = (state: AppState) => state.smsSequence.contactId;
export const getSelectedContactPhoneNumber = (state: AppState) => state.smsSequence.contactPhoneNumber;